<div
  class="flex flex-col h-[498px] space-y-6 w-[600px] xl:w-[700px] 2xl:w-[800px] 3xl:w-[850px] px-[24px] pb-4 bg-white relative rounded-lg text-black"
>
  <!-- HEADER -->
  <div
    class="flex items-start justify-between w-full border-b border-gray-200 pb-4 pt-6 text-black"
  >
    <div>
      <h2 class="text-[1.08rem] font-bold text-dimot-3">
        Personalizza il tuo prodotto
      </h2>
      <h5 class="text-[0.7rem] text-gray-600">
        Carica logo, scegli font e colori: queste informazioni verranno usate
        per personalizzare report e documenti.
      </h5>
    </div>

    <!-- Close Button -->

    <button
      (click)="closeModal()"
      class="cursor-pointer text-gray-400 hover:text-gray-600"
    >
      <svg
        width="26"
        height="26"
        viewBox="0 0 35 34"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g filter="url(#filter0_d_2900_16273)">
          <path
            d="M1.5 8C1.5 3.58172 5.08172 0 9.5 0H25.5C29.9183 0 33.5 3.58172 33.5 8V24C33.5 28.4183 29.9183 32 25.5 32H9.5C5.08172 32 1.5 28.4183 1.5 24V8Z"
            fill="white"
            shape-rendering="crispEdges"
          />
          <path
            d="M27.0298 24.4698C27.1035 24.5385 27.1626 24.6213 27.2036 24.7133C27.2446 24.8053 27.2667 24.9046 27.2684 25.0053C27.2702 25.106 27.2517 25.2061 27.214 25.2994C27.1762 25.3928 27.1201 25.4777 27.0489 25.5489C26.9777 25.6201 26.8928 25.6762 26.7994 25.714C26.7061 25.7517 26.606 25.7702 26.5053 25.7684C26.4046 25.7667 26.3053 25.7446 26.2133 25.7036C26.1213 25.6626 26.0385 25.6035 25.9698 25.5298L17.4998 17.0611L9.02985 25.5298C8.88767 25.6623 8.69963 25.7345 8.50532 25.731C8.31102 25.7276 8.12564 25.6489 7.98822 25.5115C7.85081 25.3741 7.7721 25.1887 7.76867 24.9944C7.76524 24.8001 7.83737 24.612 7.96985 24.4698L16.4386 15.9998L7.96985 7.52985C7.83737 7.38767 7.76524 7.19963 7.76867 7.00532C7.7721 6.81102 7.85081 6.62564 7.98822 6.48822C8.12564 6.35081 8.31102 6.2721 8.50532 6.26867C8.69963 6.26524 8.88767 6.33737 9.02985 6.46985L17.4998 14.9386L25.9698 6.46985C26.112 6.33737 26.3001 6.26524 26.4944 6.26867C26.6887 6.2721 26.8741 6.35081 27.0115 6.48822C27.1489 6.62564 27.2276 6.81102 27.231 7.00532C27.2345 7.19963 27.1623 7.38767 27.0298 7.52985L18.5611 15.9998L27.0298 24.4698Z"
            fill="#141F58"
          />
        </g>
      </svg>
    </button>
  </div>

  <div class="flex flex-row gap-8">
    <div class="w-1/2 pr-14">
      <label class="block text-dimot-3 mb-1">
        <h3 class="text-[1.2rem] mb-4">Logo:</h3>
        <h3 class="text-[0.75rem] mb-2">
          {{
            imagePreview ? "Anteprima" : "Inserisci il logo del tuo Prodotto"
          }}
        </h3>
      </label>

      <!-- Input hidden -->
      <input
        type="file"
        accept="image/*"
        class="hidden"
        [(ngModel)]="editedMedicineData.medicineBrandInfo.logo.url"
        (change)="onFileSelected($event)"
        #fileInput
      />

      <!-- Container upload -->
      <div
        *ngIf="!imagePreview"
        class="w-full h-42 border-2 border-dashed border-gray-300 bg-gray-100 rounded-lg flex flex-col items-center justify-center text-center text-gray-400 text-xs 2xl:text-sm cursor-pointer hover:border-dimot-1 transition relative"
        (click)="fileInput.click()"
      >
        <img
          src="./assets/img/Icons/upload.svg"
          class="w-6 h-6 2xl:w-7 2xl:h-7 mb-1"
        />
        <div>
          <div
            class="flex flex-row text-[0.65em] 2xl:text-[0.7em] justify-center"
          >
            <h5>Click to upload &nbsp;</h5>
            <span class="relative right-1">or drag and drop</span>
          </div>
          <p class="text-[0.65em] 2xl:text-[0.7em]">
            SVG, PNG, JPG o GIF (MAX. 800x400px)
          </p>
        </div>
      </div>

      <!-- Preview immagine  -->
      <div
        *ngIf="imagePreview"
        class="w-full flex items-center relative justify-center"
      >
        <div>
          <img
            [src]="imagePreview"
            alt="Logo azienda"
            class="w-50 h-50 object-contain rounded-full bg-gray-50"
          />
        </div>
        <button
          (click)="removeImage(fileInput)"
          class="absolute top-3 right-[45px] xl:right-[55px] 2xl:right-[75px] 3xl:right-[90px] cursor-pointer"
        >
          <svg
            width="28"
            height="28"
            viewBox="0 0 34 34"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_d_2964_22644)">
              <mask id="path-1-inside-1_2964_22644" fill="white">
                <path
                  d="M1 8C1 3.58172 4.58172 0 9 0H25C29.4183 0 33 3.58172 33 8V24C33 28.4183 29.4183 32 25 32H9C4.58172 32 1 28.4183 1 24V8Z"
                />
              </mask>
              <path
                d="M1 8C1 3.58172 4.58172 0 9 0H25C29.4183 0 33 3.58172 33 8V24C33 28.4183 29.4183 32 25 32H9C4.58172 32 1 28.4183 1 24V8Z"
                fill="white"
                shape-rendering="crispEdges"
              />
              <path
                d="M9 0V1H25V0V-1H9V0ZM33 8H32V24H33H34V8H33ZM25 32V31H9V32V33H25V32ZM1 24H2V8H1H0V24H1ZM9 32V31C5.13401 31 2 27.866 2 24H1H0C0 28.9706 4.02944 33 9 33V32ZM33 24H32C32 27.866 28.866 31 25 31V32V33C29.9706 33 34 28.9706 34 24H33ZM25 0V1C28.866 1 32 4.13401 32 8H33H34C34 3.02944 29.9706 -1 25 -1V0ZM9 0V-1C4.02944 -1 0 3.02944 0 8H1H2C2 4.13401 5.13401 1 9 1V0Z"
                fill="#141F58"
                mask="url(#path-1-inside-1_2964_22644)"
              />
              <path
                d="M21.169 19.7057C21.2012 19.7358 21.2271 19.772 21.245 19.8123C21.263 19.8525 21.2726 19.896 21.2734 19.94C21.2742 19.9841 21.2661 20.0278 21.2496 20.0687C21.2331 20.1095 21.2085 20.1467 21.1773 20.1778C21.1462 20.209 21.1091 20.2335 21.0682 20.25C21.0273 20.2665 20.9836 20.2747 20.9395 20.2739C20.8955 20.2731 20.852 20.2635 20.8118 20.2455C20.7715 20.2276 20.7353 20.2017 20.7053 20.1695L16.9996 16.4644L13.294 20.1695C13.2318 20.2275 13.1495 20.259 13.0645 20.2575C12.9795 20.256 12.8984 20.2216 12.8383 20.1615C12.7782 20.1013 12.7437 20.0202 12.7422 19.9352C12.7407 19.8502 12.7723 19.7679 12.8303 19.7057L16.5353 16.0001L12.8303 12.2945C12.7723 12.2323 12.7407 12.15 12.7422 12.065C12.7437 11.98 12.7782 11.8989 12.8383 11.8388C12.8984 11.7787 12.9795 11.7442 13.0645 11.7427C13.1495 11.7412 13.2318 11.7728 13.294 11.8307L16.9996 15.5358L20.7053 11.8307C20.7675 11.7728 20.8497 11.7412 20.9347 11.7427C21.0197 11.7442 21.1008 11.7787 21.161 11.8388C21.2211 11.8989 21.2555 11.98 21.257 12.065C21.2585 12.15 21.227 12.2323 21.169 12.2945L17.4639 16.0001L21.169 19.7057Z"
                fill="#141F58"
              />
            </g>
            <defs>
              <filter
                id="filter0_d_2964_22644"
                x="0.45"
                y="0"
                width="33.1"
                height="33.55"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                  result="hardAlpha"
                />
                <feMorphology
                  radius="0.05"
                  operator="dilate"
                  in="SourceAlpha"
                  result="effect1_dropShadow_2964_22644"
                />
                <feOffset dy="1" />
                <feGaussianBlur stdDeviation="0.25" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0.113725 0 0 0 0 0.160784 0 0 0 0 0.239216 0 0 0 0.02 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow_2964_22644"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow_2964_22644"
                  result="shape"
                />
              </filter>
            </defs>
          </svg>
        </button>
      </div>
    </div>
    <div class="w-1/2">
      <div>
        <h3 class="text-[1.2rem] mb-4 text-dimot-1">Font:</h3>
        <h3 class="text-[0.75rem] mb-2 text-dimot-1">
          Inserire font e colori del tuo Prodotto
        </h3>
      </div>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-6 my-4">
        <div class="flex flex-col">
          <div class="flex items-center gap-2">
            <label for="fontTitle" class="text-[#0D1C4D] mb-1"
              ><h3 class="text-[0.83rem]">Titoli</h3></label
            >
            <div class="group relative inline-block">
              <svg
                class="w-[14px] h-[14px] block group-hover:hidden"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_2172_35480)">
                  <path
                    d="M12.9375 16.875C12.9375 17.0604 12.8825 17.2417 12.7795 17.3958C12.6765 17.55 12.5301 17.6702 12.3588 17.7411C12.1875 17.8121 11.999 17.8307 11.8171 17.7945C11.6353 17.7583 11.4682 17.669 11.3371 17.5379C11.206 17.4068 11.1167 17.2398 11.0805 17.0579C11.0443 16.876 11.0629 16.6875 11.1339 16.5162C11.2048 16.3449 11.325 16.1985 11.4792 16.0955C11.6333 15.9925 11.8146 15.9375 12 15.9375C12.2486 15.9375 12.4871 16.0363 12.6629 16.2121C12.8387 16.3879 12.9375 16.6264 12.9375 16.875ZM12 6.9375C10.0313 6.9375 8.4375 8.36719 8.4375 10.125V10.5C8.4375 10.6492 8.49677 10.7923 8.60226 10.8977C8.70775 11.0032 8.85082 11.0625 9 11.0625C9.14919 11.0625 9.29226 11.0032 9.39775 10.8977C9.50324 10.7923 9.5625 10.6492 9.5625 10.5V10.125C9.5625 8.98781 10.6556 8.0625 12 8.0625C13.3444 8.0625 14.4375 8.98781 14.4375 10.125C14.4375 11.2622 13.3444 12.1875 12 12.1875C11.8508 12.1875 11.7077 12.2468 11.6023 12.3523C11.4968 12.4577 11.4375 12.6008 11.4375 12.75V13.5C11.4375 13.6492 11.4968 13.7923 11.6023 13.8977C11.7077 14.0032 11.8508 14.0625 12 14.0625C12.1492 14.0625 12.2923 14.0032 12.3978 13.8977C12.5032 13.7923 12.5625 13.6492 12.5625 13.5V13.2731C14.2603 13.0312 15.5625 11.7113 15.5625 10.125C15.5625 8.36719 13.9688 6.9375 12 6.9375ZM21.5625 12C21.5625 13.8913 21.0017 15.7401 19.9509 17.3126C18.9002 18.8852 17.4067 20.1108 15.6594 20.8346C13.9121 21.5584 11.9894 21.7477 10.1345 21.3788C8.27951 21.0098 6.57564 20.099 5.2383 18.7617C3.90096 17.4244 2.99022 15.7205 2.62125 13.8656C2.25227 12.0106 2.44164 10.0879 3.16541 8.34059C3.88917 6.59327 5.11482 5.09981 6.68736 4.04907C8.25991 2.99833 10.1087 2.4375 12 2.4375C14.5352 2.44048 16.9658 3.44891 18.7584 5.24158C20.5511 7.03425 21.5595 9.46478 21.5625 12ZM20.4375 12C20.4375 10.3312 19.9427 8.69992 19.0155 7.31238C18.0884 5.92484 16.7706 4.84338 15.2289 4.20477C13.6871 3.56615 11.9906 3.39906 10.3539 3.72462C8.71722 4.05019 7.2138 4.85378 6.03379 6.03379C4.85379 7.21379 4.05019 8.71721 3.72463 10.3539C3.39907 11.9906 3.56616 13.6871 4.20477 15.2289C4.84338 16.7706 5.92484 18.0884 7.31238 19.0155C8.69992 19.9426 10.3312 20.4375 12 20.4375C14.237 20.435 16.3817 19.5453 17.9635 17.9635C19.5453 16.3817 20.435 14.237 20.4375 12Z"
                    fill="#6A7282"
                  />
                  <g filter="url(#filter0_d_2172_35480)"></g>
                </g>
                <defs>
                  <filter
                    id="filter0_d_2172_35480"
                    x="-62"
                    y="-52"
                    width="148"
                    height="53"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feMorphology
                      radius="1"
                      operator="erode"
                      in="SourceAlpha"
                      result="effect1_dropShadow_2172_35480"
                    />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="3" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_2172_35480"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_2172_35480"
                      result="shape"
                    />
                  </filter>
                  <clipPath id="clip0_2172_35480">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>

              <svg
                class="tooltip-trigger w-[14px] h-[14px] hidden group-hover:block"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.9375 16.875C12.9375 17.0604 12.8825 17.2417 12.7795 17.3958C12.6765 17.55 12.5301 17.6702 12.3588 17.7411C12.1875 17.8121 11.999 17.8307 11.8171 17.7945C11.6353 17.7583 11.4682 17.669 11.3371 17.5379C11.206 17.4068 11.1167 17.2398 11.0805 17.0579C11.0443 16.876 11.0629 16.6875 11.1339 16.5162C11.2048 16.3449 11.325 16.1985 11.4792 16.0955C11.6333 15.9925 11.8146 15.9375 12 15.9375C12.2486 15.9375 12.4871 16.0363 12.6629 16.2121C12.8387 16.3879 12.9375 16.6264 12.9375 16.875ZM12 6.9375C10.0313 6.9375 8.4375 8.36719 8.4375 10.125V10.5C8.4375 10.6492 8.49677 10.7923 8.60226 10.8977C8.70775 11.0032 8.85082 11.0625 9 11.0625C9.14919 11.0625 9.29226 11.0032 9.39775 10.8977C9.50324 10.7923 9.5625 10.6492 9.5625 10.5V10.125C9.5625 8.98781 10.6556 8.0625 12 8.0625C13.3444 8.0625 14.4375 8.98781 14.4375 10.125C14.4375 11.2622 13.3444 12.1875 12 12.1875C11.8508 12.1875 11.7077 12.2468 11.6023 12.3523C11.4968 12.4577 11.4375 12.6008 11.4375 12.75V13.5C11.4375 13.6492 11.4968 13.7923 11.6023 13.8977C11.7077 14.0032 11.8508 14.0625 12 14.0625C12.1492 14.0625 12.2923 14.0032 12.3978 13.8977C12.5032 13.7923 12.5625 13.6492 12.5625 13.5V13.2731C14.2603 13.0312 15.5625 11.7113 15.5625 10.125C15.5625 8.36719 13.9688 6.9375 12 6.9375ZM21.5625 12C21.5625 13.8913 21.0017 15.7401 19.9509 17.3126C18.9002 18.8852 17.4067 20.1108 15.6594 20.8346C13.9121 21.5584 11.9894 21.7477 10.1345 21.3788C8.27951 21.0098 6.57564 20.099 5.2383 18.7617C3.90096 17.4244 2.99022 15.7205 2.62125 13.8656C2.25227 12.0106 2.44164 10.0879 3.16541 8.34059C3.88917 6.59327 5.11482 5.09981 6.68736 4.04907C8.25991 2.99833 10.1087 2.4375 12 2.4375C14.5352 2.44048 16.9658 3.44891 18.7584 5.24158C20.5511 7.03425 21.5595 9.46478 21.5625 12ZM20.4375 12C20.4375 10.3312 19.9427 8.69992 19.0155 7.31238C18.0884 5.92484 16.7706 4.84338 15.2289 4.20477C13.6871 3.56615 11.9906 3.39906 10.3539 3.72462C8.71722 4.05019 7.2138 4.85378 6.03379 6.03379C4.85379 7.21379 4.05019 8.71721 3.72463 10.3539C3.39907 11.9906 3.56616 13.6871 4.20477 15.2289C4.84338 16.7706 5.92484 18.0884 7.31238 19.0155C8.69992 19.9426 10.3312 20.4375 12 20.4375C14.237 20.435 16.3817 19.5453 17.9635 17.9635C19.5453 16.3817 20.435 14.237 20.4375 12Z"
                  fill="#141F58"
                />
              </svg>
            </div>
            <div
              role="tooltip"
              class="tooltip-content absolute transform -translate-x-1 mt-1 w-40 text-center normal-case z-10 invisible px-3 py-2 text-xs font-medium text-white bg-dimot-1 rounded-lg shadow-xs opacity-0"
            >
              Inserisci il nome del font esattamente come appare in PowerPoint.
              <div class="tooltip-arrow" data-popper-arrow></div>
            </div>
          </div>
          <input
            id="fontTitle"
            name="fontTitle"
            [(ngModel)]="editedMedicineData.medicineBrandInfo.font.title"
            class="w-full mt-1 h-8 px-2 bg-white border border-gray-300 rounded py-1 text-[0.75rem] text-black"
          />
        </div>
        <div class="flex flex-col">
          <div class="flex items-center gap-2">
            <label
              for="fontSubtitle"
              class="text-[#0D1C4D] text-[1em] 2xl:text-[1.1em] font-semibold mb-1"
              ><h3 class="text-[0.83rem]">Testi:</h3></label
            >
            <div class="group relative inline-block">
              <svg
                class="w-[14px] h-[14px] block group-hover:hidden"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_2172_35480)">
                  <path
                    d="M12.9375 16.875C12.9375 17.0604 12.8825 17.2417 12.7795 17.3958C12.6765 17.55 12.5301 17.6702 12.3588 17.7411C12.1875 17.8121 11.999 17.8307 11.8171 17.7945C11.6353 17.7583 11.4682 17.669 11.3371 17.5379C11.206 17.4068 11.1167 17.2398 11.0805 17.0579C11.0443 16.876 11.0629 16.6875 11.1339 16.5162C11.2048 16.3449 11.325 16.1985 11.4792 16.0955C11.6333 15.9925 11.8146 15.9375 12 15.9375C12.2486 15.9375 12.4871 16.0363 12.6629 16.2121C12.8387 16.3879 12.9375 16.6264 12.9375 16.875ZM12 6.9375C10.0313 6.9375 8.4375 8.36719 8.4375 10.125V10.5C8.4375 10.6492 8.49677 10.7923 8.60226 10.8977C8.70775 11.0032 8.85082 11.0625 9 11.0625C9.14919 11.0625 9.29226 11.0032 9.39775 10.8977C9.50324 10.7923 9.5625 10.6492 9.5625 10.5V10.125C9.5625 8.98781 10.6556 8.0625 12 8.0625C13.3444 8.0625 14.4375 8.98781 14.4375 10.125C14.4375 11.2622 13.3444 12.1875 12 12.1875C11.8508 12.1875 11.7077 12.2468 11.6023 12.3523C11.4968 12.4577 11.4375 12.6008 11.4375 12.75V13.5C11.4375 13.6492 11.4968 13.7923 11.6023 13.8977C11.7077 14.0032 11.8508 14.0625 12 14.0625C12.1492 14.0625 12.2923 14.0032 12.3978 13.8977C12.5032 13.7923 12.5625 13.6492 12.5625 13.5V13.2731C14.2603 13.0312 15.5625 11.7113 15.5625 10.125C15.5625 8.36719 13.9688 6.9375 12 6.9375ZM21.5625 12C21.5625 13.8913 21.0017 15.7401 19.9509 17.3126C18.9002 18.8852 17.4067 20.1108 15.6594 20.8346C13.9121 21.5584 11.9894 21.7477 10.1345 21.3788C8.27951 21.0098 6.57564 20.099 5.2383 18.7617C3.90096 17.4244 2.99022 15.7205 2.62125 13.8656C2.25227 12.0106 2.44164 10.0879 3.16541 8.34059C3.88917 6.59327 5.11482 5.09981 6.68736 4.04907C8.25991 2.99833 10.1087 2.4375 12 2.4375C14.5352 2.44048 16.9658 3.44891 18.7584 5.24158C20.5511 7.03425 21.5595 9.46478 21.5625 12ZM20.4375 12C20.4375 10.3312 19.9427 8.69992 19.0155 7.31238C18.0884 5.92484 16.7706 4.84338 15.2289 4.20477C13.6871 3.56615 11.9906 3.39906 10.3539 3.72462C8.71722 4.05019 7.2138 4.85378 6.03379 6.03379C4.85379 7.21379 4.05019 8.71721 3.72463 10.3539C3.39907 11.9906 3.56616 13.6871 4.20477 15.2289C4.84338 16.7706 5.92484 18.0884 7.31238 19.0155C8.69992 19.9426 10.3312 20.4375 12 20.4375C14.237 20.435 16.3817 19.5453 17.9635 17.9635C19.5453 16.3817 20.435 14.237 20.4375 12Z"
                    fill="#6A7282"
                  />
                  <g filter="url(#filter0_d_2172_35480)"></g>
                </g>
                <defs>
                  <filter
                    id="filter0_d_2172_35480"
                    x="-62"
                    y="-52"
                    width="148"
                    height="53"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                  >
                    <feFlood flood-opacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                      in="SourceAlpha"
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                      result="hardAlpha"
                    />
                    <feMorphology
                      radius="1"
                      operator="erode"
                      in="SourceAlpha"
                      result="effect1_dropShadow_2172_35480"
                    />
                    <feOffset dy="4" />
                    <feGaussianBlur stdDeviation="3" />
                    <feColorMatrix
                      type="matrix"
                      values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                    />
                    <feBlend
                      mode="normal"
                      in2="BackgroundImageFix"
                      result="effect1_dropShadow_2172_35480"
                    />
                    <feBlend
                      mode="normal"
                      in="SourceGraphic"
                      in2="effect1_dropShadow_2172_35480"
                      result="shape"
                    />
                  </filter>
                  <clipPath id="clip0_2172_35480">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>

              <svg
                class="tooltip-trigger w-[14px] h-[14px] hidden group-hover:block"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.9375 16.875C12.9375 17.0604 12.8825 17.2417 12.7795 17.3958C12.6765 17.55 12.5301 17.6702 12.3588 17.7411C12.1875 17.8121 11.999 17.8307 11.8171 17.7945C11.6353 17.7583 11.4682 17.669 11.3371 17.5379C11.206 17.4068 11.1167 17.2398 11.0805 17.0579C11.0443 16.876 11.0629 16.6875 11.1339 16.5162C11.2048 16.3449 11.325 16.1985 11.4792 16.0955C11.6333 15.9925 11.8146 15.9375 12 15.9375C12.2486 15.9375 12.4871 16.0363 12.6629 16.2121C12.8387 16.3879 12.9375 16.6264 12.9375 16.875ZM12 6.9375C10.0313 6.9375 8.4375 8.36719 8.4375 10.125V10.5C8.4375 10.6492 8.49677 10.7923 8.60226 10.8977C8.70775 11.0032 8.85082 11.0625 9 11.0625C9.14919 11.0625 9.29226 11.0032 9.39775 10.8977C9.50324 10.7923 9.5625 10.6492 9.5625 10.5V10.125C9.5625 8.98781 10.6556 8.0625 12 8.0625C13.3444 8.0625 14.4375 8.98781 14.4375 10.125C14.4375 11.2622 13.3444 12.1875 12 12.1875C11.8508 12.1875 11.7077 12.2468 11.6023 12.3523C11.4968 12.4577 11.4375 12.6008 11.4375 12.75V13.5C11.4375 13.6492 11.4968 13.7923 11.6023 13.8977C11.7077 14.0032 11.8508 14.0625 12 14.0625C12.1492 14.0625 12.2923 14.0032 12.3978 13.8977C12.5032 13.7923 12.5625 13.6492 12.5625 13.5V13.2731C14.2603 13.0312 15.5625 11.7113 15.5625 10.125C15.5625 8.36719 13.9688 6.9375 12 6.9375ZM21.5625 12C21.5625 13.8913 21.0017 15.7401 19.9509 17.3126C18.9002 18.8852 17.4067 20.1108 15.6594 20.8346C13.9121 21.5584 11.9894 21.7477 10.1345 21.3788C8.27951 21.0098 6.57564 20.099 5.2383 18.7617C3.90096 17.4244 2.99022 15.7205 2.62125 13.8656C2.25227 12.0106 2.44164 10.0879 3.16541 8.34059C3.88917 6.59327 5.11482 5.09981 6.68736 4.04907C8.25991 2.99833 10.1087 2.4375 12 2.4375C14.5352 2.44048 16.9658 3.44891 18.7584 5.24158C20.5511 7.03425 21.5595 9.46478 21.5625 12ZM20.4375 12C20.4375 10.3312 19.9427 8.69992 19.0155 7.31238C18.0884 5.92484 16.7706 4.84338 15.2289 4.20477C13.6871 3.56615 11.9906 3.39906 10.3539 3.72462C8.71722 4.05019 7.2138 4.85378 6.03379 6.03379C4.85379 7.21379 4.05019 8.71721 3.72463 10.3539C3.39907 11.9906 3.56616 13.6871 4.20477 15.2289C4.84338 16.7706 5.92484 18.0884 7.31238 19.0155C8.69992 19.9426 10.3312 20.4375 12 20.4375C14.237 20.435 16.3817 19.5453 17.9635 17.9635C19.5453 16.3817 20.435 14.237 20.4375 12Z"
                  fill="#141F58"
                />
              </svg>
            </div>
            <div
              role="tooltip"
              class="tooltip-content absolute transform -translate-x-1 mt-1 w-40 text-center normal-case z-10 invisible px-3 py-2 text-xs font-medium text-white bg-dimot-1 rounded-lg shadow-xs opacity-0"
            >
              Inserisci il nome del font esattamente come appare in PowerPoint
              <div class="tooltip-arrow" data-popper-arrow></div>
            </div>
          </div>
          <input
            id="fontSubtitle"
            name="fontSubtitle"
            [(ngModel)]="editedMedicineData.medicineBrandInfo.font.subtitle"
            class="w-full mt-1 h-8 px-2 bg-white border border-gray-300 rounded py-1 text-[0.75rem] text-black"
          />
        </div>
      </div>

      <div class="mt-10">
        <label class="block text-[#0D1C4D] font-semibold mb-1">
          <h3 class="text-[1.2rem] mb-4">Colori:</h3>
        </label>

        <div class="grid grid-cols-3 gap-3 2xl:gap-4">
          <div>
            <label class="block text-[0.83rem] text-dimot-1 mb-2"
              ><h3>Titoli</h3></label
            >
            <div class="flex max-w-[110px] xl:max-w-[120px] 2xl:max-w-[130px]">
              <input
                type="color"
                [(ngModel)]="editedMedicineData.medicineBrandInfo.colors.title"
                (input)="updateHex('titleColor', 'titleHex')"
                class="w-[33px] h-[28px] border border-gray-300 rounded-l-lg cursor-pointer p-0"
              />
              <input
                type="text"
                [(ngModel)]="editedMedicineData.medicineBrandInfo.colors.title"
                (input)="updateColor('titleHex', 'titleColor')"
                (blur)="updateColor('titleHex', 'titleColor')"
                placeholder="#000000"
                class="bg-gray-50 border border-gray-300 rounded-r px-2 py-1 flex-1 h-[28px] text-[0.6em] flex items-center text-gray-500 min-w-0 focus:outline-none"
                maxlength="7"
              />
            </div>
          </div>

          <div>
            <label class="block text-[0.83rem] text-dimot-1 mb-2"
              ><h3>Testi</h3></label
            >
            <div class="flex max-w-[110px] xl:max-w-[120px] 2xl:max-w-[130px]">
              <input
                type="color"
                [(ngModel)]="
                  editedMedicineData.medicineBrandInfo.colors.subtitle
                "
                (input)="updateHex('textColor', 'textHex')"
                class="w-[33px] h-[28px] border border-gray-300 rounded-l-lg cursor-pointer p-0"
              />
              <input
                type="text"
                [(ngModel)]="
                  editedMedicineData.medicineBrandInfo.colors.subtitle
                "
                (input)="updateColor('textHex', 'textColor')"
                (blur)="updateColor('textHex', 'textColor')"
                placeholder="#969696"
                class="bg-gray-50 border border-gray-300 rounded-r px-2 py-1 flex-1 h-[28px] text-[0.6em] flex items-center text-gray-500 min-w-0 focus:outline-none"
                maxlength="7"
              />
            </div>
          </div>

          <div>
            <label class="block text-[0.83rem] text-dimot-1 mb-2"
              ><h3>Sfondo</h3></label
            >
            <div class="flex max-w-[110px] xl:max-w-[120px] 2xl:max-w-[130px]">
              <input
                type="color"
                [(ngModel)]="
                  editedMedicineData.medicineBrandInfo.colors.background
                "
                (input)="updateHex('bgColor', 'bgHex')"
                class="w-[33px] h-[28px] border border-gray-300 rounded-l-lg cursor-pointer p-0"
              />
              <input
                type="text"
                [(ngModel)]="
                  editedMedicineData.medicineBrandInfo.colors.background
                "
                (input)="updateColor('bgHex', 'bgColor')"
                (blur)="updateColor('bgHex', 'bgColor')"
                placeholder="#FFFFFF"
                class="bg-gray-50 border border-gray-300 rounded-r px-2 py-1 flex-1 h-[28px] text-[0.6em] flex items-center text-gray-500 min-w-0 focus:outline-none"
                maxlength="7"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="canUserSave" class="text-center flex justify-center mt-7">
    <!-- Button -->
    <div class="flex justify-start">
      <button
        (click)="onSaveChanges()"
        class="border-1 border-dimot-1 bg-dimot-1 text-white hover:bg-gray-50 hover:text-dimot-1 w-36 h-[36px] rounded-lg flex flex-row justify-center gap-2 items-center cursor-pointer group"
      >
        <svg
          class="block group-hover:hidden"
          width="16"
          height="16"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.5415 17.5V13.5292C13.5413 13.355 13.5067 13.1826 13.4398 13.0219C13.373 12.8611 13.275 12.7151 13.1517 12.5922C13.0283 12.4693 12.8819 12.3719 12.7209 12.3056C12.5598 12.2393 12.3873 12.2054 12.2132 12.2058H7.7865C7.61236 12.2054 7.43984 12.2393 7.27881 12.3056C7.11778 12.3719 6.97139 12.4693 6.84802 12.5922C6.72465 12.7151 6.62672 12.8611 6.55983 13.0219C6.49293 13.1826 6.45839 13.355 6.45817 13.5292V17.5M13.5415 2.73751V4.70584C13.5413 4.87998 13.5067 5.05237 13.4398 5.21316C13.373 5.37394 13.275 5.51996 13.1517 5.64286C13.0283 5.76577 12.8819 5.86315 12.7209 5.92943C12.5598 5.99572 12.3873 6.02961 12.2132 6.02918H7.7865C7.61236 6.02961 7.43984 5.99572 7.27881 5.92943C7.11778 5.86315 6.97139 5.76577 6.84802 5.64286C6.72465 5.51996 6.62672 5.37394 6.55983 5.21316C6.49293 5.05237 6.45839 4.87998 6.45817 4.70584V2.50001M13.5415 2.73751C13.1959 2.58099 12.8209 2.50003 12.4415 2.50001H6.45817M13.5415 2.73751C13.8282 2.86751 14.0923 3.04918 14.3198 3.27501L16.3048 5.25418C16.5513 5.49944 16.7469 5.79096 16.8805 6.112C17.0141 6.43304 17.0829 6.77729 17.0832 7.12501V14.8517C17.083 15.2 17.0141 15.5449 16.8804 15.8666C16.7468 16.1883 16.551 16.4805 16.3044 16.7265C16.0577 16.9725 15.7649 17.1674 15.4429 17.3001C15.1208 17.4329 14.7757 17.5008 14.4273 17.5H5.57317C5.22482 17.5009 4.87971 17.4331 4.55759 17.3004C4.23547 17.1678 3.94266 16.973 3.69591 16.7271C3.44916 16.4812 3.25332 16.1891 3.11958 15.8674C2.98584 15.5457 2.91683 15.2009 2.9165 14.8525V5.14668C2.91694 4.79839 2.98603 4.45361 3.11982 4.13205C3.2536 3.81048 3.44947 3.51845 3.69621 3.27264C3.94294 3.02683 4.23572 2.83207 4.55778 2.69949C4.87985 2.56692 5.22489 2.49913 5.57317 2.50001H6.45817"
            stroke="white"
            stroke-width="0.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>

        <svg
          class="hidden group-hover:block"
          width="16"
          height="16"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.5415 17.5V13.5292C13.5413 13.355 13.5067 13.1826 13.4398 13.0219C13.373 12.8611 13.275 12.7151 13.1517 12.5922C13.0283 12.4693 12.8819 12.3719 12.7209 12.3056C12.5598 12.2393 12.3873 12.2054 12.2132 12.2058H7.7865C7.61236 12.2054 7.43984 12.2393 7.27881 12.3056C7.11778 12.3719 6.97139 12.4693 6.84802 12.5922C6.72465 12.7151 6.62672 12.8611 6.55983 13.0219C6.49293 13.1826 6.45839 13.355 6.45817 13.5292V17.5M13.5415 2.73751V4.70584C13.5413 4.87998 13.5067 5.05237 13.4398 5.21316C13.373 5.37394 13.275 5.51996 13.1517 5.64286C13.0283 5.76577 12.8819 5.86315 12.7209 5.92943C12.5598 5.99572 12.3873 6.02961 12.2132 6.02918H7.7865C7.61236 6.02961 7.43984 5.99572 7.27881 5.92943C7.11778 5.86315 6.97139 5.76577 6.84802 5.64286C6.72465 5.51996 6.62672 5.37394 6.55983 5.21316C6.49293 5.05237 6.45839 4.87998 6.45817 4.70584V2.50001M13.5415 2.73751C13.1959 2.58099 12.8209 2.50003 12.4415 2.50001H6.45817M13.5415 2.73751C13.8282 2.86751 14.0923 3.04918 14.3198 3.27501L16.3048 5.25418C16.5513 5.49944 16.7469 5.79096 16.8805 6.112C17.0141 6.43304 17.0829 6.77729 17.0832 7.12501V14.8517C17.083 15.2 17.0141 15.5449 16.8804 15.8666C16.7468 16.1883 16.551 16.4805 16.3044 16.7265C16.0577 16.9725 15.7649 17.1674 15.4429 17.3001C15.1208 17.4329 14.7757 17.5008 14.4273 17.5H5.57317C5.22482 17.5009 4.87971 17.4331 4.55759 17.3004C4.23547 17.1678 3.94266 16.973 3.69591 16.7271C3.44916 16.4812 3.25332 16.1891 3.11958 15.8674C2.98584 15.5457 2.91683 15.2009 2.9165 14.8525V5.14668C2.91694 4.79839 2.98603 4.45361 3.11982 4.13205C3.2536 3.81048 3.44947 3.51845 3.69621 3.27264C3.94294 3.02683 4.23572 2.83207 4.55778 2.69949C4.87985 2.56692 5.22489 2.49913 5.57317 2.50001H6.45817"
            stroke="#141F58"
            stroke-width="0.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M13.5415 17.5V13.5292C13.5413 13.355 13.5067 13.1826 13.4398 13.0219C13.373 12.8611 13.275 12.7151 13.1517 12.5922C13.0283 12.4693 12.8819 12.3719 12.7209 12.3056C12.5598 12.2393 12.3873 12.2054 12.2132 12.2058H7.7865C7.61236 12.2054 7.43984 12.2393 7.27881 12.3056C7.11778 12.3719 6.97139 12.4693 6.84802 12.5922C6.72465 12.7151 6.62672 12.8611 6.55983 13.0219C6.49293 13.1826 6.45839 13.355 6.45817 13.5292V17.5M13.5415 2.73751V4.70584C13.5413 4.87998 13.5067 5.05237 13.4398 5.21316C13.373 5.37394 13.275 5.51996 13.1517 5.64286C13.0283 5.76577 12.8819 5.86315 12.7209 5.92943C12.5598 5.99572 12.3873 6.02961 12.2132 6.02918H7.7865C7.61236 6.02961 7.43984 5.99572 7.27881 5.92943C7.11778 5.86315 6.97139 5.76577 6.84802 5.64286C6.72465 5.51996 6.62672 5.37394 6.55983 5.21316C6.49293 5.05237 6.45839 4.87998 6.45817 4.70584V2.50001M13.5415 2.73751C13.1959 2.58099 12.8209 2.50003 12.4415 2.50001H6.45817M13.5415 2.73751C13.8282 2.86751 14.0923 3.04918 14.3198 3.27501L16.3048 5.25418C16.5513 5.49944 16.7469 5.79096 16.8805 6.112C17.0141 6.43304 17.0829 6.77729 17.0832 7.12501V14.8517C17.083 15.2 17.0141 15.5449 16.8804 15.8666C16.7468 16.1883 16.551 16.4805 16.3044 16.7265C16.0577 16.9725 15.7649 17.1674 15.4429 17.3001C15.1208 17.4329 14.7757 17.5008 14.4273 17.5H5.57317C5.22482 17.5009 4.87971 17.4331 4.55759 17.3004C4.23547 17.1678 3.94266 16.973 3.69591 16.7271C3.44916 16.4812 3.25332 16.1891 3.11958 15.8674C2.98584 15.5457 2.91683 15.2009 2.9165 14.8525V5.14668C2.91694 4.79839 2.98603 4.45361 3.11982 4.13205C3.2536 3.81048 3.44947 3.51845 3.69621 3.27264C3.94294 3.02683 4.23572 2.83207 4.55778 2.69949C4.87985 2.56692 5.22489 2.49913 5.57317 2.50001H6.45817"
            stroke="black"
            stroke-opacity="0.2"
            stroke-width="0.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        <span class="text-[0.7em]">Salva Modifiche</span>
      </button>
    </div>
  </div>
</div>
